import AccessServiceBadge from "./AccessServiceBadge";

export default AccessServiceBadge;
